/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import { bool, number, string } from "prop-types";
import { classes } from "../utils/classes";
import pureFC from "../utils/pureFC";

const Label = ({ className = "", uppercase = true, width, inverted = false, ...props }) => (
	<label
		className={classes(
			"field__label",
			!uppercase && "field__label--transform-none",
			inverted && "field__label--inverted",
			width && `w-${width}`,
			className,
		)}
		{...props}
	/>
);

Label.propTypes = {
	uppercase: bool,
	width: number,
	className: string,
	inverted: bool,
};

export default pureFC(Label);
